import React from "react";
import "./footer.css";
import {
  FaFacebookF,
  FaInstagram,
  FaYoutube,
  FaLinkedinIn,
} from "react-icons/fa";
// import { FaXTwitter } from "react-icons/fa6";

const Footer = () => {
  return (
    <footer className="custom-footer">
      <div className="footer-container">
        {/* Columna izquierda */}
        <div className="footer-column">
          <p>@ Alfin Contacto 2025 / All Rights Reserved</p>
        </div>

        {/* Columna centro con redes */}
        <div className="footer-column center">
          <p>Conoce nuestras novedades en :</p>
          <div className="social-icons">           
            <a href="https://web.facebook.com/AlfinBanco" target="_blank" rel="noreferrer">
              <FaFacebookF />
            </a>
            <a href="https://www.instagram.com/alfinbanco" target="_blank" rel="noreferrer">
              <FaInstagram />
            </a>
            <a href="https://www.youtube.com/@AlfinBanco" target="_blank" rel="noreferrer">
              <FaYoutube />
            </a>
            <a href="https://www.linkedin.com/company/alfin-banco" target="_blank" rel="noreferrer">
              <FaLinkedinIn />
            </a>
          </div>
        </div>

        {/* Columna derecha */}
        <div className="footer-column right">
          <p>Banca Telefónica: 01 613 0004</p>
          <p>Powered By: ALFIN BANCO</p>
        </div>
      </div>
    </footer>
  );
  
};

export default Footer;
